"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableRowStyles = void 0;
exports.tableRowStyles = {
    root: function (_a) {
        var header = _a.props.header, colorScheme = _a.theme.siteVariables.colorScheme;
        return __assign(__assign({ borderBottomColor: colorScheme.default.border2 }, (header && { "--table-cell__content--font-size": "0.75rem" })), { "&:hover": {
                backgroundColor: "".concat(colorScheme.default.background4, " !important"),
                borderLeftColor: "".concat(colorScheme.default.background4, " !important"),
                borderTopColor: "".concat(colorScheme.default.background4, " !important"),
                borderRightColor: "".concat(colorScheme.default.background4, " !important"),
                borderBottomColor: "".concat(colorScheme.default.border2, " !important"),
            } });
    },
};
//# sourceMappingURL=tableRow-styles.js.map